const ISSUE_NAME = {
  XMPP_DISCONNECTED: 'XMPP 断开链接，但不是 4000 - 5000的错误码',
  XMPP_CONNECT_FAIL: 'XMPP 建连失败',
  JOIN_FAIL: '进会失败',
  JOIN_FAIL_TIMEOUT: '进会超时',

  STREAM_NO_MEDIA: '更新的流没有媒体数据',
  SWITCH_BIG_STREAM_ERROR: '切换大流错误',
  SWITCH_SMALL_STREAM_ERROR: '切换小流错误',

  FPS_SLOW: '帧率低于 5 FPS',
  CLIENT_BANNED: 'TRTC用户踢出',

  UNMUTE_AUDIO_ERROR: 'trtc打开麦克风失败',
  MUTE_AUDIO_ERROR: 'trtc关闭麦克风失败',
  UNMUTE_VIDEO_ERROR: 'trtc打开视频失败',
  MUTE_VIDEO_ERROR: 'trtc关闭视频失败',
} as const;

export default ISSUE_NAME;
